var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: " currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.653 15.567 9.11 4.774c-.467-2.243-4.378-2.243-4.824 0l-2.15 11.05m11.212-.257 1.558-10.793c.398-2.273 4.338-2.456 4.823 0l2.15 11.05M9.73 8.861c1.159-.523 3.265-.57 4.548 0M8.795 16.35c.062.608-.219 1.172-.7 1.545M6.613 19.1h.032m3.413-7.906c1.133-.446 2.793-.461 3.887 0m5.948 5.157c.062.608-.218 1.172-.7 1.545m-1.39 1.204h.032M6.444 21C3.99 21 2 18.956 2 16.816c0-2.141 1.99-4.114 4.444-4.114 2.455 0 4.445 1.973 4.445 4.114 0 2.14-1.99 4.184-4.445 4.184Zm11.112 0c-2.455 0-4.445-2.044-4.445-4.184 0-2.141 1.99-4.114 4.445-4.114 2.454 0 4.444 1.973 4.444 4.114C22 18.956 20.01 21 17.556 21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.5d776ac32109f0a5812d3edc09ed30c9.svg";
export { ForwardRef as ReactComponent };